
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, Getter, Action, Mutation } from "vuex-class";
import Sessions from "@/components/Sessions.vue";
import Cameras from "@/components/Cameras.vue";
import LinkingCamera from "@/components/LinkingCamera.vue";
import ManualRaise from "@/components/ManualRaise.vue";
import { SessionResource } from '@/store/sessions/types';
import { EventDetails } from "@/store/site-monitor/types";

const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		cameras: Cameras,
		session: Sessions,
		"link-camera": LinkingCamera,
		"manual-raise": ManualRaise,
	}
})
export default class SiteMonitorCameras extends Vue {
	@Getter isLoggedIn: any;
	@Getter getActiveRegion;
	@Getter getFeature: (featureName: string[]) => boolean;
	@Action updateActiveRegion: any;

	@SiteMonitor.Mutation private setActivity: () => void;
	@SiteMonitor.Getter("getEventDetails") eventDetails: EventDetails;
	
	private auditServiceSessionResourceId = SessionResource.AuditServiceSession;
	private deviceServiceSessionResourceId = SessionResource.DeviceServiceSession;		
	private currentEventGroupLayoutPref: number = -1;		
	private mousedownHandler: (e: MouseEvent) => void;

	/** Life Cycle Hooks */

	private async mounted(): Promise<void> {
		this.mousedownHandler = (e: MouseEvent) => { this.setActivity(); };
		this.$el.addEventListener("mousedown", this.mousedownHandler);
	}

	private created(): void {
		//As this window is in a separate window we need to retrieve the active region from the shared store
		//and call the update ActiveRegion action which will update the api's base url to point at the correct region
		this.updateActiveRegion(this.getActiveRegion);
		window.zE('webWidget', 'hide');
	}

	private beforeDestroy(): void {
		if (this.mousedownHandler) {
			this.$el.removeEventListener("mousedown", this.mousedownHandler);
		}
	}

	/** Watchers */

	@Watch("isLoggedIn")
	private onIsLoggedInChanged(value: boolean, oldValue: boolean) {
		if (!value) {
			console.error("auto close media matrix - Site Monitor Cameras: User is not logged in, closing window.");
			window.close();
		}
	}

	@Watch("eventDetails", { immediate: true })
	private async onEventDetailsChanged(newValue: EventDetails): Promise<void> {
		if (this.isCloseOnEventEndEnabled) {
			if (!newValue || newValue.eventID === 0) {
				window.close();
			}
		}
	}

	/** Computed Props */

	private get eventId(): number {
		try {
			return this.eventDetails == null ? 0 : this.eventDetails.eventID;
		} catch (err) {
			return 0;
		}
	}

	public get mediaMatrixEnabled(): boolean {
		return this.getFeature(["Alarms", "MediaMatrix"]);
	}

	public get linkedCamerasEnabled(): boolean {
		return this.getFeature(["Alarms", "MediaMatrix", "LinkedCameras"]);
	}

	public get isCloseOnEventEndEnabled(): boolean {
		return this.getFeature(["Alarms", "MediaMatrix", "CloseOnEnd"]);
	}
}
